import React from "react";
import { MdSchool } from "react-icons/md";
import {
  VerticalTimeline,
  VerticalTimelineElement,
} from "react-vertical-timeline-component";
import "react-vertical-timeline-component/style.min.css";
import "./Education.css";
const Education = () => {
  return (
    <>
      <div className=" education" id="education">
        <h2 className="col-12 mt-3 mb-1 text-center text-uppercase">
          Education Details
        </h2>
        <hr />
        <VerticalTimeline>
          <VerticalTimelineElement
            className="vertical-timeline-element--work"
            contentStyle={{ background: "var(--bg-primary)", color: "var(--text-primary)" }}
            contentArrowStyle={{ borderRight: "7px solid var(--bg-primary)" }}
            date="2021 - 2025"
            iconStyle={{ background: "var(--primary-color)", color: "#fff" }}
            icon={<MdSchool />}
          >
            <h3 className="vertical-timeline-element-title">B.Tech.</h3>
            <h4 className="vertical-timeline-element-subtitle">
              Techno India NJR Institute of Technology, Udaipur, Rajasthan, IN
            </h4>
          </VerticalTimelineElement>
          <VerticalTimelineElement
            className="vertical-timeline-element--work"
            contentStyle={{ background: "var(--bg-primary)", color: "var(--text-primary)" }}
            contentArrowStyle={{ borderRight: "7px solid var(--bg-primary)" }}
            date="2019 - 2020"
            iconStyle={{ background: "var(--primary-color)", color: "#fff" }}
            icon={<MdSchool />}
          >
            <h3 className="vertical-timeline-element-title">Class 12th</h3>
            <h4 className="vertical-timeline-element-subtitle">
              St. Anthony's Sr. Sec. School, Udaipur, Rajasthan, IN
            </h4>
          </VerticalTimelineElement>
          <VerticalTimelineElement
            className="vertical-timeline-element--work"
            contentStyle={{ background: "var(--bg-primary)", color: "var(--text-primary)" }}
            contentArrowStyle={{ borderRight: "7px solid var(--bg-primary)" }}
            date="2018 - 2019"
            iconStyle={{ background: "var(--primary-color)", color: "#fff" }}
            icon={<MdSchool />}
          >
            <h3 className="vertical-timeline-element-title">Class 10th</h3>
            <h4 className="vertical-timeline-element-subtitle">
              St. Paul's Sr. Sec. School, Udaipur, Rajasthan, IN
            </h4>
          </VerticalTimelineElement>
        </VerticalTimeline>
      </div>
    </>
  );
};

export default Education;
